import { Injectable } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class FormsHelperService {
  constructor() {}

  // `instanceof` plutôt que `constructor.name` : Angular nomme la classe runtime
  // `FormControl2` dans le bundle fesm (et un nom mangé en prod minifiée), donc
  // un `case "FormControl"` ne matchait JAMAIS → les FormControl n'étaient pas
  // marqués dirty/touched. `instanceof` est robuste quel que soit le nom.
  static markDirtyTouched(control: AbstractControl) {
    if (control instanceof FormGroup) {
      this.markGroupDirty(control);
    } else if (control instanceof FormArray) {
      this.markArrayDirty(control);
    } else if (control instanceof FormControl) {
      this.markControlDirty(control);
    }
  }

  static markGroupDirty(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      this.markDirtyTouched(formGroup.get(key));
    });
  }
  static markArrayDirty(formArray: FormArray) {
    formArray.controls.forEach((control) => {
      this.markDirtyTouched(control);
    });
  }
  static markControlDirty(formControl: FormControl) {
    formControl.markAsDirty();
    formControl.markAsTouched();
  }

  static clearFormArray(formArray: FormArray, emitEvent = true) {
    while (formArray.length !== 0) {
      formArray.removeAt(0, { emitEvent: emitEvent });
    }
  }

  static isAbstractControl(v: unknown): v is AbstractControl {
    return (
      v instanceof AbstractControl ||
      (v != null &&
        typeof v === "object" &&
        "invalid" in v &&
        "updateValueAndValidity" in v)
    );
  }
}
